import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'end',
    width: '100%',
    justifyContent: 'end',
    gap: theme.spacing(3),
  },
  button: {
    justifySelf: 'flex-start',
    fontSize: '0.9rem',
    height: '3.55rem',
  },
}));

export default useStyles;
